// extracted by mini-css-extract-plugin
export var blue = "bF_g8";
export var button = "bF_b7";
export var label = "bF_c8";
export var orange = "bF_g9";
export var white = "bF_gm";